// import React, { useState } from 'react';
// import "./TodoList.css"
// function TodoList() {
//   const [todos, setTodos] = useState(JSON.parse(localStorage.getItem('todos')) || []);
//   const [editingIndex, setEditingIndex] = useState(null);
//   const [inputText, setInputText] = useState('');
//   const [newTodo, setNewTodo] = useState('');
//   function handleAddTodo(e) {
//     e.preventDefault();

//     if(inputText) {
//       setTodos([...todos, { text: inputText }]);
//       setInputText('');
//     }
//     if(editingIndex !== null) {
//       handleUpdateTodo(editingIndex);
//     }
//     else {
//       handleAddTodo();
//     }
//     localStorage.setItem('todos', JSON.stringify(todos));
//   }

//   function handleEditTodo(index) {

//     setEditingIndex(index);
//     setInputText(todos[index].text);

//   }

//   function handleUpdateTodo(index) {
//     if(inputText) {
//       const newTodos = [...todos];
//       newTodos[index].text = inputText;
//       setTodos(newTodos);
//       setEditingIndex(null);
//       setInputText('');
//     }
//   }

//   function handleDeleteTodo(index) {
//     const newTodos = [...todos];
//     newTodos.splice(index, 1);
//     setTodos(newTodos);
//   }

//   return (
//     <div>
//       <form className='todo' onSubmit={handleAddTodo}>
//         <input type="text" value={inputText} onChange={e => setInputText(e.target.value)} placeholder="Add/Edit todo" />
//         <button type="submit">Save</button>
//       </form>
//       <ul>
//         {todos.map((todo, index) => (
//           <li key={index}>
//             {todo.text}
//             <button onClick={() => handleEditTodo(index)}>Edit</button>
//             <button onClick={() => handleDeleteTodo(index)}>Delete</button>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// }

// export default TodoList;

// import React, { useState } from 'react';
// import "./TodoList.css"
// function TodoList() {
//   const [todos, setTodos] = useState(
//     JSON.parse(localStorage.getItem('todos')) || []
//   );
//   const [newTodo, setNewTodo] = useState("");
//   const [editing, setEditing] = useState(null);

//   function handleAddTodo(e) {
//     e.preventDefault();
//     setTodos([...todos, newTodo]);
//     setNewTodo("");
//     localStorage.setItem("todos", JSON.stringify(todos));
//   }

//   function handleEditTodo(index) {
//     setEditing(index);
//     setNewTodo(todos[index]);
//   }

//   function handleSaveTodo(e) {
//     e.preventDefault();
//     const updatedTodos = [...todos];
//     updatedTodos[editing] = newTodo;
//     setTodos(updatedTodos);
//     setEditing(null);
//     setNewTodo("");
//     localStorage.setItem("todos", JSON.stringify(updatedTodos));
//   }

//   function handleDeleteTodo(index) {
//     const updatedTodos = [...todos];
//     updatedTodos.splice(index, 1);
//     setTodos(updatedTodos);
//     localStorage.setItem("todos", JSON.stringify(updatedTodos));
//   }

//   return (
//     <div>
//       <form className='todo' onSubmit={handleAddTodo}>
//         <input
//           type="text"
//           value={newTodo}
//           onChange={(e) => setNewTodo(e.target.value)}
//           placeholder={editing !== null ? "Edit Todo" : "Add Todo"}
//         />
//         <button type="submit">
//           {editing !== null ? <button type="button" onClick={handleSaveTodo}>Save</button> : "Add"}
//         </button>
//       </form>
//       <ul>
//         {todos.map((todo, index) => (
//           <li key={index}>
//             {todo}
//             <button onClick={() => handleEditTodo(index)}>Edit</button>
//             <button onClick={() => handleDeleteTodo(index)}>Delete</button>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// }

// export default TodoList;

import React, { useState } from "react";
import "./TodoList.css";
function TodoList() {
  // initialize the todos state from the localStorage
  const [todos, setTodos] = useState(() => {
    const localData = localStorage.getItem("todos");
    return localData ? JSON.parse(localData) : [];
  });
  // input field state
  const [newTodoTitle, setNewTodoTitle] = useState("");
  // input field state for the description
  const [newTodoDescription, setNewTodoDescription] = useState("");
  // index of the todo that is being edited
  const [editingIndex, setEditingIndex] = useState(null);

  function handleAddTodo(e) {
    e.preventDefault();
    setTodos([
      ...todos,
      { title: newTodoTitle, description: newTodoDescription },
    ]);
    setNewTodoTitle("");
    setNewTodoDescription("");
    localStorage.setItem(
      "todos",
      JSON.stringify([
        ...todos,
        { title: newTodoTitle, description: newTodoDescription },
      ])
    );
  }

  function handleEditTodo(index) {
    setEditingIndex(index);
    setNewTodoTitle(todos[index].title);
    setNewTodoDescription(todos[index].description);
  }

  function handleSaveTodo(e) {
    e.preventDefault();
    const updatedTodos = [...todos];
    updatedTodos[editingIndex] = {
      title: newTodoTitle,
      description: newTodoDescription,
    };
    setTodos(updatedTodos);
    setEditingIndex(null);
    setNewTodoTitle("");
    setNewTodoDescription("");

    localStorage.setItem("todos", JSON.stringify(updatedTodos));
  }

  function handleDeleteTodo(index) {
    const updatedTodos = [...todos];
    updatedTodos.splice(index, 1);
    setTodos(updatedTodos);
    localStorage.setItem("todos", JSON.stringify(updatedTodos));
  }


  // const [file, setFile] = useState(null);

  // const handleFileChange = (e) => {
  //   setFile(e.target.files[0]);
  // };

  // const handleFileUpload = () => {
  //   if (file) {
  //     const fileType = file.type.split("/")[0];
  //     if (fileType !== "image" && fileType !== "video") {
  //       alert("Invalid file type. Please upload an image or video.");
  //       return;
  //     }
  //     console.log(file)
  //     localStorage.setItem("file", file);
  //   } else {
  //     alert("No file selected.");
  //   }
  // };

  const [todoItems, setTodoItems] = useState([]);
  const [newItem, setNewItem] = useState('');
  const [image, setImage] = useState(null);
  const [video, setVideo] = useState(null);

  const handleTodoSubmit = (e) => {
    e.preventDefault();
    setTodoItems([...todoItems, newItem]);
    setNewItem('');
  };

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleVideoChange = (e) => {
    setVideo(e.target.files[0]);
  };

  const handleUpload = () => {
    if (image) {
      localStorage.setItem('image', URL.createObjectURL(image));
    
    }
    console.log(image)
  
    if (video) {
      localStorage.setItem('video', URL.createObjectURL(video));
    }
  };



  return (
    <div >
      
      <form className="todo">
        <h1 className="text-center ">Design Comming Soon</h1>
        <input
          type="text"
          value={newTodoTitle}
          onChange={(e) => setNewTodoTitle(e.target.value)}
          placeholder={
            editingIndex !== null ? "Edit Todo Title " : "Add Todo Title"
          }
        />
        <br /><br />
        <textarea
          type="text"
          value={newTodoDescription}
          onChange={(e) => setNewTodoDescription(e.target.value)}
          placeholder={
            editingIndex !== null
              ? "Edit Todo Description"
              : "Add Todo Description"
          }
        />
        <br />
        {editingIndex !== null ? (
          <button type="button" onClick={handleSaveTodo}>
            Save
          </button>
        ) : (
          <button type="button" onClick={handleAddTodo}>
            Add
          </button>
        )}


      </form>
      <ul>
        {todos.map((todo, index) => (
          <li key={index}>
            <h3>{todo.title}</h3>
            <p>{todo.description}</p>
            <button onClick={() => handleEditTodo(index)}>Edit</button>
            <button onClick={() => handleDeleteTodo(index)}>Delete</button>
          </li>
        ))}
      </ul>



 
  

      <div>
      <h2>Todo List</h2>
      <form onSubmit={handleTodoSubmit}>
        <input
          type="text"
          value={newItem}
          onChange={(e) => setNewItem(e.target.value)}
        />
        <button type="submit">Add</button>
      </form>
      <ul>
        {todoItems.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
      <h2>Upload</h2>
      <input type="file" accept="image/*" onChange={handleImageChange} />
      <input type="file" accept="video/*" onChange={handleVideoChange} />
      <button onClick={handleUpload}>Upload</button>
    </div>


   
    </div>
  );
}

export default TodoList;
